<script setup>
/**
 * FormControlMBasketOrdersCustomerEmailMessageId
 * Pass-through interface to render the system's customer email communication log
 * within the basket order orchestration view.
 */
import OrdersEmails from '@/common/form-control/OrdersEmails.vue';

defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});
</script>

<template>
    <OrdersEmails v-bind="$props"/>
</template>